<template>
  <transition name="alert" appear>
    <div class="alert-content" :class="{ 'alert-success': props.type === 'success', 'alert-error': props.type === 'error' }">
      <div class="alert-message">
        <p class="alert-message-text" :class="{ 'font-alert': isCustomFont }">{{ props.message }}</p>
      </div>
      <button class="alert-close" type="button" @click="closeAlert()"></button>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  message: String,
  type: String,
  id: String,
  autoclose: {
    type: Boolean,
    default: false,
  },
});
const store = useStore();

const emit = defineEmits(['remove']);

const activeTimeout = ref(-1);

const errorFields = computed(() => store.getters['common/errorFields']);
const isCustomFont = computed(() => props.message?.includes("¥"));

const setTimeoutHandler = () => {
  window.clearTimeout(activeTimeout.value);
  if (props.type === 'success' && !props.autoclose) {
    activeTimeout.value = window.setTimeout(() => {
      closeAlert();
    }, 3000);
  }
};
const closeAlert = () => {
  if (errorFields.value?.issueCoupon) {
    window.location.reload();
  }
  emit('remove');
};

onMounted(() => {
  setTimeoutHandler();
});

watch(() => props.type, () => {
  setTimeoutHandler();
});
</script>

<style scoped>
  .font-alert {
    font-family: 'ヒラギノ角ゴ ProN', 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', Helvetica, Arial, sans-serif !important;
  }
  .alert-message-text {
    line-height: 1.15;
  }
</style>
